<template>
  <div class="bg-gray-100">
    <div
      v-if="loadingVisible"
      class="min-h-screen flex items-center justify-center"
    >
      <div class="flex gap-4 justify-start items-center">
        <img
          src="@/assets/inpocket-full-logo.svg"
          width="250"
        />
        <ProgressSpinner
          style="width: 40px; height: 40px"
          strokeWidth="6"
        />
      </div>
    </div>

    <div v-else>
      <Toast :life="5000" />
      <ChatmessageToastV2 v-if="isChatNewDesign" />
      <DynamicDialog />

      <router-view />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, nextTick, watch } from 'vue'
import { useAuthModel } from '@/features/auth'
import { useSalespointStore } from '@/store'
import { useSelectSalespointModel } from '@/features/salespoint'
import { storeToRefs } from 'pinia'
import Toast from 'primevue/toast'
import DynamicDialog from 'primevue/dynamicdialog'
import ProgressSpinner from 'primevue/progressspinner'
import { useMortgageStore } from '@/entities/mortgage'
import { useMortgageTablePageStore } from '@/pages/mortgage/MortgageTablePage/mortgage-table-page-store'
import { useFeatureFlag, useFeatureFlagsStore } from '@/shared/lib/feature-flags'

const ChatmessageToastV2 = defineAsyncComponent(() =>
  import('@/widgets/ChatmessageToastV2').then(module => module.ChatmessageToastV2)
)

const authModel = useAuthModel()
const salespointStore = useSalespointStore()
const featureFlagsStore = useFeatureFlagsStore()
const isChatNewDesign = useFeatureFlag('chatNewDesign')

const { openModal } = useSelectSalespointModel()
const { user, isAuthorized, checkLoginPending } = storeToRefs(authModel)
const { salespoint, getSalespointPending } = storeToRefs(salespointStore)

const loadingVisible = computed(() => checkLoginPending.value)

useMortgageStore()

useMortgageTablePageStore()

watch(
  [() => user.value?.id ?? null, () => user.value?.groups_ids ?? [], () => salespoint.value?.id ?? null],
  ([userId, groupIds, salespointId]) => featureFlagsStore.setContext({ userId, groupIds, salespointId }),
  { immediate: true }
)

watch(
  [checkLoginPending, isAuthorized, getSalespointPending],
  ([checkLoginPending, isAuthorized, getSalespointPending]) => {
    nextTick(() => {
      if (isAuthorized && !checkLoginPending && !salespoint.value && !getSalespointPending) {
        openModal()
      }
    })
  }
)


console.log('ТЕСТ CI/CD')
</script>
